import React from 'react';
import {
  Flex,
  Heading,
  Box,
  FormikField,
  TextInput,
  rem,
  Checkbox,
  Text,
} from '@feast-it/pesto';
import { baseTheme, TextLink } from '@feast-it/ui';
import { ThemeProvider } from 'emotion-theming';

import paths from '../../../constants/paths';

const SupplierDetails = () => {
  return (
    <Flex flexDirection="column" alignItems="center">
      <Heading
        textAlign="center"
        mb={{ _: 2, m: 4 }}
        color="blueDark"
        fontSize={{ _: 'headingExtraLargeMobile', m: 'headingLargeMobile' }}
        lineHeight={{
          _: 'headingExtraLargeMobile',
          m: 'headingLargeMobile',
        }}
        fontWeight={500}
      >
        Your contact details
      </Heading>

      <Text
        color="blueDark"
        textAlign="center"
        mb={4}
        fontFamily="body"
        fontSize={{ _: 'body', m: 'headingMediumMobile' }}
        lineHeight={{ _: 'body', m: 'headingMediumMobile' }}
      >
        Let us know how we can contact you about your application.
      </Text>

      <Box mt={{ _: 6, l: 11 }} width={{ _: '100%', l: 'auto' }}>
        <Flex
          width={{ _: '100%', m: rem(620) }}
          justifyContent="space-between"
          flexDirection={{ _: 'column', l: 'row' }}
        >
          <FormikField
            width={{ _: '100%', l: rem(290) }}
            as={TextInput}
            label="First name"
            name="user.firstName"
            color="blueDark"
            fontFamily="body"
          />

          <FormikField
            mt={{ _: 6, l: 0 }}
            width={{ _: '100%', l: rem(290) }}
            as={TextInput}
            label="Last name"
            name="user.lastName"
            color="blueDark"
            fontFamily="body"
          />
        </Flex>

        <FormikField
          mt={4}
          width="100%"
          as={TextInput}
          label="Email address"
          placeholder="name@example.com"
          name="user.email"
          color="blueDark"
          fontFamily="body"
        />
        <FormikField
          mt={6}
          width="100%"
          as={TextInput}
          label="Phone number"
          name="user.phone"
          color="blueDark"
          fontFamily="body"
        />

        <Flex
          justifyContent="space-between"
          mt={6}
          flexDirection={{ _: 'column', l: 'row' }}
        >
          <FormikField
            type="password"
            width={{ _: '100%', l: rem(290) }}
            as={TextInput}
            label="Password"
            name="user.password"
            color="blueDark"
            fontFamily="body"
          />

          <FormikField
            mt={{ _: 6, l: 0 }}
            type="password"
            width={{ _: '100%', l: rem(290) }}
            as={TextInput}
            label="Confirm password"
            name="user.passwordConfirmation"
            color="blueDark"
            fontFamily="body"
          />
        </Flex>

        <FormikField
          mt={8}
          as={Checkbox}
          name="user.terms"
          label={
            <>
              I agree to the{' '}
              <ThemeProvider theme={baseTheme}>
                <TextLink
                  isInline={true}
                  href={paths.PARTNER_TERMS}
                  color="mediumBlue"
                  fontWeight={500}
                  style="bodyMedium"
                >
                  T&amp;Cs
                </TextLink>{' '}
                and{' '}
                <TextLink
                  isInline={true}
                  href={paths.PRIVACY}
                  color="mediumBlue"
                  fontWeight={500}
                  style="bodyMedium"
                >
                  Privacy Policy
                </TextLink>
              </ThemeProvider>
            </>
          }
          color="blueDark"
          fontFamily="body"
        />
      </Box>
    </Flex>
  );
};

export default SupplierDetails;
